import { Injectable } from '@angular/core';
import { RxEmitter } from '../rxjs/rx-emitter';
import { Subscription } from 'rxjs';
import { DqRemoteControlMessage, DqRemoteControlCommands } from './dq-remote-control-message';
import { StreamService } from 'common/dynamicquery/stream.service';

const DYNAMIC_QUERY_METHOD_NAME = 'remoteControlMessage';
const RX_ADDRESS_PREFIX = `${DYNAMIC_QUERY_METHOD_NAME}_event_`;

@Injectable()
export class RemoteControlMessageService {
  constructor(
    private Stream: StreamService,
    private RxEmitter: RxEmitter
  ) {
    this.Stream.registerMessageHandler(DYNAMIC_QUERY_METHOD_NAME, this._sendUpdatesToSubscribers.bind(this));
  }

  private _sendUpdatesToSubscribers(params) {
    this.RxEmitter.send(RX_ADDRESS_PREFIX , this._parseMessageParameters(params));
  }

  private _parseMessageParameters(params): DqRemoteControlMessage {
    const parsedParams = JSON.parse(params);

    let command: DqRemoteControlCommands;

    switch (parsedParams.command) {
      case DqRemoteControlCommands.accepted:
        command = DqRemoteControlCommands.accepted;
        break;
      case DqRemoteControlCommands.cancelled:
        command = DqRemoteControlCommands.cancelled;
        break;
      case DqRemoteControlCommands.declined:
        command = DqRemoteControlCommands.declined;
        break;
      default:
        throw new Error(`This dynamic query remote control command type: [${params.command}] is not recognized, please implement it or fix it.`);
    }

    return { chatId: parsedParams.chatId, command, rcHistoryId: parsedParams.rcHistoryId };
  }

  subscribe(handler): Subscription {
    return this.RxEmitter.subscribe(RX_ADDRESS_PREFIX, handler);
  }
}
